export const Token = 'cropler::accessToken';
export const RefreshToken = 'cropler::refreshToken';

export const Workspace = 'cropler::workspaceId';
export const AddWorkspaceModal = 'cropler::addWorkspaceModal';
export const MapLng = 'cropler::lng';
export const MapLat = 'cropler::lat';

export const QRCodeDeviceId = 'cropler::QRCodeDeviceId';

export const PushNotificationId = 'cropler::pushNotificationId';
export const PushNotificationToken = 'cropler::pushNotificationToken';
export const PushNotificationTokenStatus = 'cropler::pushNotificationTokenStatus'; // login, logout

export const LocalizationModal = 'cropler::localizationModalShown';
export const CustomCharts = 'cropler::customCharts';
export const DemoWorkspaceId = 'f4ef14b8-ddc7-4dec-bd2a-ac411982366a';
export const DemoWorkspaceDate = '2023-08-16';

export const APIVersion = 'v4'

export const MinDifferenceGpsAndInstall = '10' //meters

export const WebsiteLanguages = ['en', 'pl', 'ua', 'de', 'es', 'fr'];

// Mapbox
export const mapBoxId = 'pk.eyJ1IjoiY3JvcGxlciIsImEiOiJjbHI4MDRkaWsyZHA5MmpudjZjbjF1azlrIn0.-B4kl_3mRFXwmwUiV_xiHg';
export const mapBoxStyles = 'mapbox://styles/mapbox/satellite-streets-v12';

// sentinel-hub.com
export const SentinelHubId = '45d9b44a-4585-497e-a857-e79cb91ee580';
export const SentinelHubToken = '45d9b44a-4585-497e-a857-e79cb91ee580';
export const SentinelHubLayerName = 'NDVI-CROPLER';

// Google/Apple store links
export const GooglePlayUrl = 'https://play.google.com/store/apps/details?id=io.cropler.app&pli=1';
export const AppStoreUrl = 'https://apps.apple.com/by/app/cropler/id6677052772';
